module.exports = __webpack_public_path__ + "img/info-1.15f38a47.svg";